import { ImagePreview, PreviewComponentProps } from "@camberi/firecms";
import { ReactElement } from "react";

export default function CustomImagePreview({ value, property, size }: PreviewComponentProps<any>): ReactElement {
  const url = `https://kosturanov.com/${value.replace(/^upload\//, "public/")}`;
  return <ImagePreview key={`image_preview_${value}_${size}`} url={url} size={size} />;
}
